import gql from 'graphql-tag';

export default gql(`
	query ParkingStatuses {
		parking_statuses {
			created_at
	        name
	        places_total_available
	        places_free
	        places_booked
	        places_parked
	        is_full
		}
	}
`);

